import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box, Paper, TextField, Button, Typography, Alert } from '@mui/material';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';
import { handleApiError } from '../utils/errorHandler';
import { Helmet } from 'react-helmet-async';

const AdminLogin = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setCredentials({
      ...credentials,
      [e.target.name]: e.target.value
    });
    console.log(' Input changed:', e.target.name);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(' Login attempt:', { username: credentials.username });

    try {
      console.log(' Sending request to server...');
      const { username, password } = credentials;
      const response = await axios.post('/api/admin/login', {
        username,
        password,
      });
      
      console.log(' Server response:', response.data);
      if (response.data.token) {
        console.log(' Calling login with token');
        await login(response.data.token);
        console.log(' Navigating to dashboard');
        navigate('/admin/dashboard');
      }
    } catch (err) {
      console.error(' Login error:', {
        status: err.response?.status,
        message: err.response?.data?.message,
        error: err.message
      });
      handleApiError(err);
      setError('Login failed. Please check your credentials.');
    }
  };

  return (
    <>
      
      <Box
        sx={{
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: 'background.default'
        }}
      >
        <Paper
          elevation={3}
          sx={{
            p: 4,
            maxWidth: 400,
            width: '90%'
          }}
        >
          <Typography variant="h5" component="h1" gutterBottom textAlign="center">
            Admin Login
          </Typography>

          {error && (
            <Alert severity="error" sx={{ mb: 2 }}>
              {error}
            </Alert>
          )}

          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth
              label="Username"
              name="username"
              value={credentials.username}
              onChange={handleChange}
              margin="normal"
              required
            />
            <TextField
              fullWidth
              label="Password"
              name="password"
              type="password"
              value={credentials.password}
              onChange={handleChange}
              margin="normal"
              required
            />
            <Button
              fullWidth
              type="submit"
              variant="contained"
              sx={{ mt: 3 }}
            >
              Login
            </Button>
          </form>
        </Paper>
      </Box>
    </>
  );
};

export default AdminLogin;
